import "./WholesaleCTA.css"
import { Link } from "react-router-dom"
function WholesaleCTA(){

return(

<div className="wholesaleCTA">

<h2>Wholesale Lace & Accessories</h2>

<p>Bulk Orders Available for Boutiques & Designers</p>

<Link to="/b2b">
<button className="ctaBtn">
Request Wholesale Quote
</button>
</Link>

</div>

)

}

export default WholesaleCTA